/**
 * Consumable web workers for heavy computational tasks
 * @namespace Util.Workers
 */

import sort from './sort.js?worker&url';

/*
  NOTE - This is a workaround for CORs issues on WebWorkers
  https://github.com/vitejs/vite/issues/13680#issuecomment-1819274694
*/
function ExposeWorker(file) {
  const js = `import ${JSON.stringify(new URL(file, import.meta.url))}`;
  const blob = new Blob([js], { type: "application/javascript" });
  return (function(options) {
    const objURL = URL.createObjectURL(blob)
    const worker = new Worker(objURL, { type: 'module', name: options?.name })
    worker.addEventListener('error', () => {
      URL.revokeObjectURL(objURL)
    });
    return worker;
  })();
} 

/**
 * Web worker for handling heavy sorts
 * @function sortWorker
 * @memberof Util.Workers
 * @example
 * 
 * sortWorker.postMessage({
 *    rows: dataSet,
 *    key: 'some-key',
 *    reverse: true
 *  });
 *  sortWorker.onmessage = function(event) {
 *    console.log(event.data); // Sorted results
 *  }
 */
const sortWorker = new ExposeWorker(sort);

export { sortWorker };
